var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElectricityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 133,
    viewBox: "0 0 96 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6018 122.56C27.6018 124.238 28.3015 125.777 29.5604 126.897L35.2968 131.653C36.2766 132.493 37.5355 132.912 38.7945 132.912H56.7024C57.9614 132.912 59.2203 132.493 60.2001 131.653L65.9365 126.897C67.1954 125.777 67.8951 124.238 67.8951 122.56V112.067H27.3224L27.3214 122.56H27.6018Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4336 0.285428C20.8885 2.66371 3.39976 19.8718 0.741539 41.4178C-1.35763 60.3047 7.31713 77.2338 21.4474 86.7474C25.2251 89.2653 27.4629 93.323 27.4629 97.7995V101.717H68.0357V97.9392C68.0357 93.6023 70.1338 89.4049 73.772 86.8871C86.6434 78.3528 95.038 63.8031 95.038 47.2937C95.3181 19.4523 71.1146 -2.79276 42.4333 0.285178L42.4336 0.285428ZM67.8965 47.2939L44.1127 79.1925C42.0145 81.9904 37.6765 80.0318 38.3763 76.6747L42.5737 56.1085H30.6812C28.0227 56.1085 26.4838 53.0306 28.0227 50.9322L51.8065 19.0336C53.9047 16.2357 58.2427 18.1943 57.5429 21.5514L53.3455 42.1176H65.238C67.8965 42.1166 69.4355 45.0552 67.8965 47.2939Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricityIcon);
export default __webpack_public_path__ + "static/media/electricityIcon.40acf99a522238a6b5cdafa5be6d027f.svg";
export { ForwardRef as ReactComponent };